import React, {useRef, useState, useEffect} from 'react';
import {components} from '../../components';

interface DescriptionProps {
  item: {description: string};
}

const ProductDescription: React.FC<DescriptionProps> = ({item}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [iframeHeight, setIframeHeight] = useState('auto');

  useEffect(() => {
    if (!iframeRef.current) return;

    const doc = `
      <!DOCTYPE html>
      <html>
        <head>
          <style>
            body {
              margin: 0;
              padding: 16px;
              font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif;
              line-height: 1.6;
              color: #333;
              max-width: 100%; /* Ensure content doesn't overflow */
              word-wrap: break-word; /* Handle long words properly */
            }
            h1, h2, h3, h4, h5, h6 {
              color: #222;
              margin: 1em 0 0.5em;
              font-size: 1.25em; /* Make headings flexible */
            }
            p {
              margin-bottom: 1em;
            }
            ul, ol {
              padding-left: 1.5em;
              margin-bottom: 1em;
            }
            @media (max-width: 768px) {
              body {
                padding: 12px; /* Reduce padding on smaller screens */
              }
              h1, h2, h3, h4, h5, h6 {
                font-size: 1.1em; /* Adjust font size for smaller screens */
              }
            }
          </style>
        </head>
        <body>
          ${item.description}
        </body>
      </html>
    `;

    const iframe = iframeRef.current;
    const iframeDoc = iframe.contentDocument;

    if (iframeDoc) {
      iframeDoc.open();
      iframeDoc.write(doc);
      iframeDoc.close();

      const checkHeight = () => {
        if (iframeDoc.body) {
          const newHeight = iframeDoc.body.scrollHeight + 50 + 'px';
          setIframeHeight(newHeight);
        }
      };

      setTimeout(checkHeight, 50);

      const observer = new MutationObserver(checkHeight);
      observer.observe(iframeDoc.body, {
        childList: true,
        subtree: true,
        characterData: true,
      });

      window.addEventListener('resize', checkHeight);

      return () => {
        observer.disconnect();
        window.removeEventListener('resize', checkHeight);
      };
    }
  }, [item.description]);

  return (
    <div style={{marginBottom: 40}}>
      <components.BlockHeading
        title='Description'
        containerStyle={{padding: '30px 10px 0 20px', marginBottom: 2}}
        viewAllVisible={false}
      />
      <div style={{padding: '0 10px'}}>
        <iframe
          ref={iframeRef}
          title='Product Detail'
          width='100%'
          style={{
            height: iframeHeight,
            overflow: 'hidden',
            border: 'none',
            maxWidth: '100%',
          }}
        />
      </div>
    </div>
  );
};

export default ProductDescription;
